module.exports = __webpack_public_path__ + "static/media/intro-photowall-25.e66a18a2.jpg";